import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './components/App/App';
import Firebase, { FirebaseContext } from './components/Firebase';
import StoreProvider from './store';

import * as serviceWorker from './serviceWorker';

const firebase = new Firebase();

ReactDOM.render(
  <StoreProvider>
    <FirebaseContext.Provider value={firebase}>
      <App />
    </FirebaseContext.Provider>
  </StoreProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
